import { Departure } from "./departure";

export class Arrival extends Departure{
    
}